import * as React from "react";
import * as authText from "../../../ui/components/Auth/authTypography.style.css";

export function SetupStepHeader({
  title,
  subtitle,
  meta,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  meta?: React.ReactNode;
}) {
  return (
    <div className={authText.setupStepHeader}>
      <h2 className={authText.titleMdCentered}>{title}</h2>
      {subtitle != null && subtitle !== false ? (
        <p className={authText.setupStepSubtitle}>{subtitle}</p>
      ) : null}
      {meta != null && meta !== false ? (
        <p className={authText.setupStepMeta}>{meta}</p>
      ) : null}
    </div>
  );
}
